import React, { useState } from "react";
import axios from "axios";
import { TextField } from "@material-ui/core";
import TwoFa from "../../../elements/twoFa/TwoFa";
import DialogModal from "../../../elements/dialogModal/DialogModal";
import { check2FA } from "../../../../utils/check2FA";
import getUserInfo from "../../../../utils/getUserInfo";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";

import DefaultButton from "../../../styles/materialButtonStyle";
import { StyledBlockAction, StyledInputBlock } from "../../../styles/styledTabsForm";

const ExchangePairsEditForm = ({ t, pair, notification, setNotification }) => {

  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [submitData, setSubmitData] = useState({
    percent: null,
    constant: null
  });

  const inputProps = {
    step: "any"
  };

  const handleSave = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.put("/api/exchange-pairs/" + pair.id, submitData, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setOpen(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("pairs.details.changeForm.success") });
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("pairs.details.changeForm.twoFa")}
        content={<TwoFa
          handleSubmit={handleSave}
          error={error}
        />}
      />
      <StyledInputBlock
        as="form"
        onSubmit={event => {
          event.preventDefault();

          setSubmitData({
            ...setSubmitData,
            percent: event.target.percent.value,
            constant: event.target.constant.value,
          });
          setOpen(true);
        }}
      >
        <TextField
          className="grid-form__input"
          variant="filled"
          label={t("pairs.details.changeForm.percent")}
          id="percent"
          type="number"
          inputProps={inputProps}
          name="percent"
          defaultValue={pair.percent * 100}
        />
        <TextField
          className="grid-form__input"
          variant="filled"
          label={t("pairs.details.changeForm.constant")}
          id="constant"
          type="number"
          inputProps={inputProps}
          name="constant"
          defaultValue={pair.constant}
        />
        <StyledBlockAction>
          <DefaultButton
            color="success"
            type="submit"
          >
            {t("pairs.details.changeForm.save")}
          </DefaultButton>
        </StyledBlockAction>
      </StyledInputBlock>
    </>
  );
};

export default ExchangePairsEditForm;